import OapMediaCarousel from './code/Scripts/components/OapMediaCarousel.vue';

export default {
  components: {
    OapMediaCarousel,
  },
};
